import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { deleteDonor } from '../../../../../redux/actions/donor.actions';

import DonorDetails from './DonorDetails';
import DonorDonations from './DonorDonations';
import LinkRecipientsDonor from './LinkRecipientsDonor';

const EmptyView = props => {
    return (
        <div className="donor-page">
            <div className="donor-header" />
            <div className="intro ">
                <div className="intro-text">Start by selecting a donor OR <span onClick={() => props.openModal()} className="link">Add Donor</span></div>
            </div>
        </div>
    );
};

class DonorPage extends Component {
    shouldComponentUpdate(nextProps) {
        return (nextProps.match.params.clientId !== this.props.match.params.clientId) ||
            (nextProps.donorState.donors !== this.props.donorState.donors)
    }
    openModal = () => {
        const { donorState: { donorsById } } = this.props;
        const { clientId } = this.props.match.params;
        const donor = donorsById[clientId] || null;
        const event = new CustomEvent('open-add-donor-modal', {
            detail: donor || null
        });
        window.dispatchEvent(event);
    }
    openDeleteModal = () => {
        const { donorState: { donorsById } } = this.props;
        const { clientId } = this.props.match.params;
        const donor = donorsById[clientId];
        const { first_name, last_name, middle_name } = donor;
        const event = new CustomEvent('open-delete-modal', {
            detail: {
                content: `Are you sure you want to delete donor ${first_name} ${middle_name} ${last_name}?`,
                onDelete: () => {
                    this.props.deleteDonor(clientId);
                }
            }
        });
        window.dispatchEvent(event);
    }

    render() {
        const { match: { params: {clientId }}, donorState, userState } = this.props;
        const donor = donorState.donorsById[clientId];
        return donor ? (
            <div className="donor-page">
                <div className="donor-header">
                    <div className="full-width-title">
                        {donor.first_name} {donor.middle_name} {donor.last_name}
                    </div>
                    <div className="right-buttons">
                        <button type="button" className="pt-button pt-small pt-intent-primary pt-icon-edit" onClick={this.openModal}>Edit</button>
                        <button type="button" className="pt-button pt-small pt-intent-danger pt-icon-trash" onClick={this.openDeleteModal}>Delete</button>
                    </div>
                </div>
                <div className="donor-content">
                    <DonorDetails donorId={clientId} donorState={donorState} />
                    <DonorDonations donorId={clientId} donorState={donorState} />
                    { userState.data.is_super_admin || userState.data.is_corporate_admin ?
                        <LinkRecipientsDonor donorId={clientId} donorState={donorState} />
                        : null
                    }
                </div>
            </div>
        ): <EmptyView openModal={this.openModal} />;
    }
}

const mapStateToProps = (state) => ({
    donorState: state.donor,
    userState: state.user
});

export default withRouter(connect(
    mapStateToProps,
    { deleteDonor }
)(DonorPage));


// WEBPACK FOOTER //
// ./src/components/main/dashboard/panel/donor/DonorPage.jsx